<template>
  <div class="trendsreport-pdf-toc" ref="tocContainer">
    <h2 class="trendsreport-pdf-toc__title">Table of Contents</h2>
    <div class="trendsreport-pdf-toc__split">
      <div class="trendsreport-pdf-toc__left">
        <div v-for="(section, sectionIndex) in leftTOC" :key="sectionIndex">
          <div
            class="trendsreport-pdf-toc__section"
            v-for="(reports, key) in section"
            :key="key"
          >
            <h3 class="trendsreport-pdf-toc__section-title">{{ key }}</h3>
            <div
              class="trendsreport-pdf-toc__report"
              v-for="(report, reportIndex) in reports"
              :key="reportIndex"
            >
              <a
                class="trendsreport-pdf-toc__link"
                :href="`#${report.report_type_slug}`"
              >
                {{ report.report_type_name }}
              </a>
              <span class="trendsreport-pdf-toc__icon">&#9658;</span>
            </div>
          </div>
        </div>
      </div>
      <div class="trendsreport-pdf-toc__right">
        <div v-for="(section, sectionIndex) in rightTOC" :key="sectionIndex">
          <div
            class="trendsreport-pdf-toc__section"
            v-for="(reports, key) in section"
            :key="key"
          >
            <h4 class="trendsreport-pdf-toc__section-title">{{ key }}</h4>
            <div
              class="trendsreport-pdf-toc__report"
              v-for="(report, reportIndex) in reports"
              :key="reportIndex"
            >
              <a
                class="trendsreport-pdf-toc__link"
                :href="`#${report.report_type_slug}`"
              >
                {{ report.report_type_name }}
              </a>
              <span class="trendsreport-pdf-toc__icon">&#9658;</span>
            </div>
          </div>
        </div>
        <div class="trendsreport-pdf-toc__ask">
          <p class="trendsreport-pdf-toc__questions">Questions?</p>
          <a
            class="trendsreport-pdf-toc__email"
            href="mailto:questions@itreconomics.com"
          >
            Ask an Analyst
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed, ref } from 'vue';

  export default {
    name: 'TrendsReportPDFTableOfContents',
    components: {},
    props: {
      reports: {
        Type: Object,
        required: true,
      },
    },
    setup(props) {
      const tocContainer = ref(null);
      let leftTOC = computed(() => {
        let temp = props.reports;
        return temp.slice(0, 3);
      });

      let rightTOC = computed(() => {
        let temp = props.reports;
        return temp.slice(-2);
      });

      return {
        leftTOC,
        rightTOC,
        tocContainer,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .trendsreport-pdf-toc {
    font-family: 'Open Sans', sans-serif !important;
    &__split {
      display: flex;
      flex-wrap: nowrap;
      flex-direction: row;
      gap: 12rem;
    }
    &__title {
      color: var(--itr-blue);
      font-weight: 600;
      margin-bottom: 5rem;
      margin-top: 2rem;
      font-size: 40px;
    }
    &__section {
      margin-bottom: 3rem;
    }
    &__section-title {
      color: var(--itr-blue);
      margin-bottom: 0;
      padding-bottom: 2rem;
      border-bottom: 2px solid var(--itr-grey);
      font-size: 28px;
      font-weight: 600;
    }
    &__left,
    &__right {
      flex: 1 1 44%;
      display: flex;
      flex-direction: column;
    }
    &__report {
      display: flex;
      justify-content: space-between;
      padding: 8px 0;
      align-items: center;
      border-bottom: 2px solid var(--itr-grey);
    }
    &__link {
      font-size: 18px;
      color: var(--itr-black);
      font-weight: 600;
      text-decoration: none;
    }
    &__icon {
      font-size: 14px;
      color: var(--itr-grey-mid);
    }
    &__ask {
      margin-top: auto;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      margin-bottom: 3rem;
    }
    &__questions {
      font-size: 22px;
      color: var(--itr-grey-mid);
      font-style: italic;
    }
    &__email {
      text-decoration: underline;
      font-size: 22px;
      color: #069370;
      padding: 20px 0;
    }
  }
</style>
